<template>
	<div class="header">
		<Navbar></Navbar>
	</div>
</template>

<script>
	import Navbar from '@/components/globals/Navbar'

	export default {
		components: { Navbar },
		props: {
		}
	}
</script>

<style lang="scss" scoped>
.header {
	background: $header-bg-col;
	border-bottom: 1px solid $default-border-col;
	clear: both;
	display: flex;
	float: left;
	justify-content: center;
	position: relative;
	width: 100%;

	.mr-navbar-container {
		float: right;
		width: auto;
	}
}

body.is-dark .header {
	background: $dark-header-background-color;
	border-bottom-color: $dark-border-color;

}
</style>



// WEBPACK FOOTER //
// TopHeader.vue?3b3d3ef2